function calcGroup(groupRef, groups, teams, matches, pred) {

    let groupData = [];

    let grp = groups.filter((g) => g.ref === groupRef)[0]
    let ts = grp !== undefined && grp !== null && grp.teams !== undefined ? grp.teams : []

    ts.forEach((t) => {

        let groupMatchesForTeam = matches.filter((m) => m.stage === "group" && m.groupRef === groupRef && (m.homeTeam === t || m.awayTeam === t))
        let matchPredictionsForTeam = []

        pred
        .filter((p) => groupMatchesForTeam.some((gmft) => gmft._id === p.matchid) && 
            p.home !== undefined && p.home !== null && p.home !== '' && 
            p.away !== undefined && p.away !== null && p.away !== '')
        .forEach((p) => {
            let mtch = groupMatchesForTeam.filter((gmft) => gmft._id === p.matchid)[0]
            let teamIsHome = mtch.homeTeam === t;
            let win = (teamIsHome && p.home > p.away) || (!teamIsHome && p.home < p.away) ? 1 : 0; // Team is "home" and home wins OR Team is "away" and away wins
            let drawn = (p.home === p.away) ? 1 : 0; // Score is equal
            let lost = (teamIsHome && p.home < p.away) || (!teamIsHome && p.home > p.away) ? 1 : 0; // Team is "home" and away wins OR Team is "away" and home wins

            // Derive relevant value for this specific match
            matchPredictionsForTeam.push({
                matchid: p.matchid,
                win: win,
                lost: lost, 
                drawn: drawn,
                gf: teamIsHome ? p.home : p.away, // goals for
                ga: teamIsHome ? p.away : p.home, // goals against
                pts: (win * 3) + (drawn * 1),
            })
        })

        // Accumulate all match values into the final object
        const team = teams.filter((tm) => tm._id === t)[0];
        groupData.push({
            teamID: t,
            teamName: team !== undefined ? team.name : 'Unknown',
            teamFlag: team !== undefined ? team.flag : null,
            pld: matchPredictionsForTeam.length,
            win: matchPredictionsForTeam.reduce((acc, m) => { return acc + m.win; }, 0),
            drawn: matchPredictionsForTeam.reduce((acc, m) => { return acc + m.drawn; }, 0),
            lost: matchPredictionsForTeam.reduce((acc, m) => { return acc + m.lost; }, 0),
            gf: matchPredictionsForTeam.reduce((acc, m) => { return acc + m.gf; }, 0),
            ga: matchPredictionsForTeam.reduce((acc, m) => { return acc + m.ga; }, 0),
            gd: matchPredictionsForTeam.reduce((acc, m) => { return acc + m.gf; }, 0) - 
                matchPredictionsForTeam.reduce((acc, m) => { return acc + m.ga; }, 0),
            pts: matchPredictionsForTeam.reduce((acc, m) => { return acc + m.pts; }, 0),
        })
    })

    // Todo: See sorting under https://en.wikipedia.org/wiki/FIFA_World_Cup and then under "Final tournament"
    groupData.sort((a, b) => b.pts - a.pts || b.gd - a.gd || b.gf - a.gf);

    return groupData

}

export default calcGroup